import { VehicleAttributes } from '../../../../models/vehicle-attributes';
import { useContext, useEffect, useState } from 'react';
import {
    notify,
    SlackMessages,
} from '../../../../services/slack-message-service/SlackMessageService';
import { DSL_API_PATH } from '../../../../constants';
import VehicleTypeService from '../../../../services/vehicle-type-service/vehicle-type-service';
import ServerContext from '../../../../contexts/serverContext';

export const useVehicleAttributes = (vin: string): VehicleAttributes => {
    const [vehicleAttributes, setVehicleAttributes] = useState<
        VehicleAttributes
    >({ year: 0, model: '', make: '' });

    const { currentLanguageRegionCode, current3LetterCountryCode } = useContext(
        ServerContext
    );
    useEffect(() => {
        if (vin) {
            setVehicleAttributes({ year: -1, model: '', make: '' });

            new VehicleTypeService()
                .request(
                    vin,
                    currentLanguageRegionCode,
                    current3LetterCountryCode?.toUpperCase()
                )
                .then(response => {
                    const { year, make, model } = response.vehicleData as any;
                    const vehicles = {
                        year,
                        model,
                        make,
                        vin: vin,
                        ownerState: 1,
                    };
                    setVehicleAttributes(vehicles);
                })
                .catch(() => {
                    setVehicleAttributes({
                        year: -1,
                        model: '',
                        make: '',
                    });
                    notify(
                        SlackMessages.API_VEHICLE_ATTRIBUTES_FAILURE +
                            ' vin ' +
                            vin +
                            ' dsl api ' +
                            DSL_API_PATH.VEHICLE_TYPE
                    );
                });
        }
    }, [vin]);
    return vehicleAttributes;
};
